import React from "react";
import Screenshot from "../imgs/cuimhne.png";

export const Cuimhne = () => {
  return (
    <div className="itemContainer">
      <div className="itemContained">
        <img
          src={Screenshot}
          alt="Cuimhne"
          className="screenshot"

        />
      </div>
      <div
        className="itemContained itemExplainer"

      >
        <center>
          <span className="itemTitle">Cuimhne</span>
          <br />
          <br />

          <span className="itemBody">
            A game to practice vocab
          </span>
        </center>
      </div>
    </div>
  );
};
